/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import './index.scss'
import { Popover } from 'antd'

const ghRecod = '该信息应以车辆登记证书登记为准。'
const overdue = '商业险是否随车赠送，需在交易过程中与车主确认。'
const ReportBasicInfo = ({
  testObject, newTestReport, testReport, carCity, isReInspection
}) => {
  const handleSplitObj = (obj) => {
    const newArr = []
    const refeArr = obj && Object.keys(obj)
    if (!Array.isArray(refeArr)) { return [] }
    const dfs = () => {
      if (refeArr.length === 0) {
        return
      }
      newArr.push(
        <div className="tr" key={newArr.length}>
          {
             refeArr.splice(0, 3).map((item, index) => (
               <span key={index}>
                 <div key={(newArr.length + 1) * 100 + index} className="td ellips">{item}</div>
                 <div key={(newArr.length + 2) * 200 + index} className="td ellips">
                   {item === '过户记录' && (<span>{obj[item]}</span>)}
                   {item !== '过户记录' && (<span>{obj[item] || '--'}</span>)}

                   {item === '过户记录' && (
                   <Popover content={ghRecod}>
                     <i className="iconfont icon-tip-icon2-07d8d303" />
                   </Popover>
                   )}
                   {item === '商业险过期日期' && (
                   <Popover content={overdue}>
                     <i className="iconfont icon-tip-icon2-07d8d303" />
                   </Popover>
                   )}
                 </div>
               </span>
             ))
           }
        </div>
      )
      dfs()
    }
    dfs()
    return newArr
  }

  return (
    <>
      <div className="inspectTit">
        <div className="title">人人车检测报告</div>
        <div className="headLine ellips">
          <span className="line-pd">{isReInspection === 1 ? '复检' : '初检'}检测时间: {testReport?.date}</span>
          <span className="line-pd">检测城市: {carCity}</span>
          <span title={testObject}>检测对象: {testObject}</span>
        </div>
      </div>
      <div className="basic_info ">
        <div className="title ellips">基础信息</div>
        <div className="basic_table">
          <div className="table">
            {handleSplitObj(newTestReport && newTestReport.report && newTestReport.report['车辆信息'])}
          </div>
        </div>
      </div>
    </>
  )
}
export default ReportBasicInfo

ReportBasicInfo.propTypes = {
  testObject: PropTypes.any,
  newTestReport: PropTypes.object,
  testReport: PropTypes.any,
  carCity: PropTypes.string,
  isReInspection: PropTypes.number
}

ReportBasicInfo.defaultProps = {
  testObject: null,
  newTestReport: {},
  testReport: {},
  carCity: '',
  isReInspection: 0
}
